import React, { memo, useState } from "react";
import { 
  CheckSquare, 
  Square, 
  Trash2, 
  MessageSquare, 
  Send, 
  CheckCircle, 
  RotateCcw,
  X
} from "lucide-react";
import { stockProductionService } from "../../services/stockProductionService";

const hasBomRecipe = (sku, bomSkuSet) => {
  if (!sku || !bomSkuSet) return false;
  const cleanSku = sku.trim().toUpperCase();
  if (bomSkuSet.has(cleanSku)) return true;
  
  const parts = cleanSku.split("-");
  if (parts.length > 1) {
    for (let i = parts.length - 1; i >= 1; i--) {
      const parentSku = parts.slice(0, i).join("-");
      if (bomSkuSet.has(parentSku)) return true;
    }
  }
  return false;
};

import ItemCard from "./ItemCard";

const StockProductionItemRow = memo((props) => {
  return <ItemCard {...props} />;
});

export default StockProductionItemRow;
